import { useUserSetting } from "hooks/UserSettingsHooks";
import { useSelector, useDispatch } from "react-redux";
import { LegacyReduxStore } from "types/common/LegacyReduxStore";
import { Settings } from "luxon";
import { changeLocale } from "containers/Shared/LanguageProvider/actions";
import { getLanguageStringFromLocaleString } from "utils/localeHelpers";
import { switchWeglotLang } from "utils/weglot";
import LocaleService from "utils/localeService";
import { useIsAuthenticated } from "core/iam/AuthenticationHooks";

export function useLanguage() {
  const localStorageValue = LocaleService.getLocale() as string;
  const isLoggedIn = useIsAuthenticated();
  const [userSettingsValue, setUserSettingValue, isLoading] = useUserSetting(
    "language",
    { query: { enabled: isLoggedIn } },
  );

  const reduxStoreValue = useSelector(
    (state: LegacyReduxStore) => state.language.locale,
  );
  const dispatch = useDispatch();

  const setLang = (lang: string) => {
    setUserSettingValue(lang);
    LocaleService.storeLocale(lang);
    Settings.defaultLocale = lang;
    switchWeglotLang(lang);
    dispatch(changeLocale(lang));
  };

  const lang =
    userSettingsValue ??
    (getLanguageStringFromLocaleString(
      reduxStoreValue ?? localStorageValue,
    ) as string);

  return [lang, setLang, isLoading] as const;
}
